import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-866 -466)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(866 466)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.554 0.0986c-3.8374-0.6007-8.4068 1.5923-9.9527 5.2422-1.3389 3.1613-0.20258 6.2464 1.0705 9.1737 1.3749 3.1586-0.21159 3.9655-0.21159 3.9655l4.7234-0.10579c2.8308-0.06276 5.6876-0.17931 8.0007-2.0352 1.3686-1.0974 2.5625-2.4539 3.2891-4.0561 2.3689-5.2279-1.3488-11.313-6.9194-12.184z",
  fill: "#A400E1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.7249 5.04h8.4702c0.44453 0 0.8049 0.37608 0.8049 0.84s-0.36036 0.84-0.8049 0.84h-8.4702c-0.44453 0-0.8049-0.37608-0.8049-0.84s0.36036-0.84 0.8049-0.84z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.7249 8.12h8.4702c0.44453 0 0.8049 0.37608 0.8049 0.84s-0.36036 0.84-0.8049 0.84h-8.4702c-0.44453 0-0.8049-0.37608-0.8049-0.84s0.36036-0.84 0.8049-0.84z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.7249 11.2h8.4702c0.28756 0 0.55328 0.1601 0.69706 0.42s0.14378 0.5801 0 0.84-0.4095 0.42-0.69706 0.42h-8.4702c-0.44453 0-0.8049-0.37608-0.8049-0.84s0.36036-0.84 0.8049-0.84z",
  fill: "#fff"
})))), 'Blog', {
  viewBox: '-3 -2 24 24'
});